/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.21.0
 * @since 1.0.0
 */
import styled from 'styled-components';

import { fonts } from '@theme/index';


/* Main container */
export const CreateInquiryContainerStyled = styled.div.attrs({
    'className': 'create-historyInquiry',
    'data-footer-create-inquiry': 'create-historyInquiry',
})`
    width: 600px;
    box-sizing: border-box;
    padding: 24px 0;
    & .create-inquiry__search,
    & .create-inquiry__footer {
        box-sizing: border-box;
    }

    & .create-inquiry__footer {
        padding: 24px 24px 0;
    }

    & .create-inquiry__search {
       padding: 0 24px;
    }
`;

/* TITLE BLOCK */
export const CreateInquiryHeaderStyled = styled.div.attrs({
    className: 'create-inquiry__header',
})`
    padding: 0 24px 24px;
    box-sizing: border-box;
`;

export const CreateInquiryTitleStyled = styled.span.attrs({
    className: 'create-inquiry__title',
})`
    display: block;
    ${fonts.textHeader3};
    margin-bottom: 4px;
`;

export const CreateInquiryClientStyled = styled.span.attrs({
    className: 'create-inquiry__client',
})``;

/* FOOTER BLOCK */
export const CreateInquiryFooterStyled = styled.div.attrs({
    'className': 'create-inquiry__footer',
    'data-label-create-inquiry': 'create-historyInquiry-footer',
})`
    display: flex;
    align-items: center;
    & .create-inquiry__footer-link {
        margin-left: 16px;
    }
`;

export const CreateInquiryFootnoteStyled = styled.span.attrs({
    className: 'create-inquiry__footnote',
})`
    ${fonts.textSmall};
`;
